<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">취약점 정보</h1>
      <h2 class="page-tit">보안 공지</h2>
    </div>
    <div class="board-list__top">
      <p class="board-list__total">총 {{ pagingInfo.total }}건</p>
      <div class="board-list__search">
        <label for="search-type" class="sr-only">검색 조건</label>
        <select name="" id="search-type" v-model="searchInfo.searchOption">
          <option value="TITLE">제목</option>
          <option value="CONTENT">내용</option>
          <option value="TOGETHER">제목 + 내용</option>
        </select>
        <label for="search-keyword" class="sr-only"
          >검색어를 입력해주세요</label
        >
        <input
          v-model="searchInfo.content"
          type="text"
          id="search-keyword"
          placeholder="검색어를 입력해주세요"
          @keyup.enter="getList(1)"
        />
        <button type="button" class="btn btn--blue btn--m" @click="getList(1)">
          <i class="svg_icon icon_search white"></i>검색
        </button>
      </div>
    </div>
    <!-- v-for 적용 테이블 -->
    <table class="board-list type-m-none-thead">
      <colgroup>
        <col width="10%" />
        <col width="70%" />
        <col width="10%" />
        <col width="10%" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">순번</th>
          <th scope="col">제목</th>
          <th scope="col">조회수</th>
          <th scope="col">작성일</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="item.id"
          @click="goToDetail(item)"
          class="clickable-row"
        >
          <td class="no-field">
            {{ convertId(index) }}
          </td>
          <td class="alignL">
            <div class="ellipsis">{{ item.title || "-" }}</div>
          </td>
          <td class="hit-field">{{ item.view_cnt }}</td>
          <td class="date-field">{{ convertDateFormatFromId(item.id) }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="items == null || items.length == 0" class="no-data">
      {{
        isLoading
          ? "데이터 조회중입니다. 잠시만 기다려주십시오."
          : "검색 결과 없음..."
      }}
    </div>
    <Paging
      v-model="pagingInfo.currentPage"
      :totalItems="pagingInfo.total"
      :visibleCount="pagingInfo.limitNum"
      @update:modelValue="getPage"
    />
  </div>
</template>

<script>
import dc from "@/component/DataChk.js";
import dt from "@/component/DateTime.js";
import paging from "@/component/Paging.js";
import tb from "@/component/Table.js";
import { computed, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();

    // data 정의
    const pagingInfo = reactive({
      currentPage: 1, // 현재페이지
      prePage: 1, // 이전페이지
      perPage: 10, // n개씩보기
      limitNum: 5, // 화면에 표시할 페이지 수
      type: 1, // 1 = 처음부터 조회, 2 = preKey/nextKey 사용, 3 = n개씩보기 변경
      total: -1,
      pageNum: 0,
      doubleTab: false,
    });
    const searchInfo = ref({
      id: "",
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      searchOption: "TITLE",
      content: "",
      collectionType: "VULNOTICE",
      tabs: "ko",
    });
    const savedSearchInfo = ref({
      // getList(1) 후 저장된 검색 조건
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      searchOption: "TITLE",
      content: "",
      collectionType: "VULNOTICE",
      tabs: "ko",
    });
    const items = ref([]);

    // methods 정의
    const getList = async (type) => {
      // 보안공지 조회

      searchInfo.value = dc.trimObject(searchInfo.value);
      const axiosSearchInfo = tb.getSearchInfo(
        type,
        searchInfo,
        savedSearchInfo
      );

      pagingInfo.type = type;
      if (type !== 2) {
        pagingInfo.total = -1;
        paging.total("/core/pu/view/count/get", axiosSearchInfo).then((res) => {
          pagingInfo.total = res;
        });
      }

      paging
        .getPageItems(
          "/core/pu/view/vuln-notice/get",
          axiosSearchInfo,
          pagingInfo
        )
        .then((res) => {
          items.value = res;
          pagingInfo.doubleTab = true;
        });

      // 검색 조건 저장
      tb.saveSearchInfo(type, searchInfo, savedSearchInfo);
    };
    const convertId = (index) => {
      // total.value 쉼표를 제거하고 숫자로 변환
      const totalCount = parseInt(
        String(pagingInfo.total).replace(/,/g, ""),
        10
      );
      if (isNaN(totalCount) || totalCount <= 0) {
        return 0;
      }
      const offset = (pagingInfo.currentPage - 1) * pagingInfo.perPage;

      if (pagingInfo.currentPage > 1) {
        return totalCount - offset - index;
      }
      return totalCount - index;
    };
    const goToDetail = (item) => {
      // 상세 페이지로 이동
      searchInfo.value.id = item.id;
      // 검색 조건을 sessionStorage에 저장
      tb.saveStateForDetail("vulnNotice", searchInfo.value, pagingInfo);
      router.push({
        name: "vulnNoticeDetail",
        query: {
          id: item.id,
        },
      });
    };
    const getPage = (page) => {
      // 페이징 클릭 시 목록 조회
      pagingInfo.currentPage = page;
      pagingInfo.pageNum = page - pagingInfo.currentPage; // 클릭한 페이지 기준 차이
      pagingInfo.doubleTab = false;
      getList(2);
    };

    const convertDateFormatFromId = (objectId) => {
      return dt.dateFromObjectId(objectId);
    };

    // computed 정의
    const isLoading = computed(() => store.state.loading.isLoading);
    const rows = computed(() => {
      if (!items.value) {
        return 0;
      }
      return items.value.length;
    });
    // life cycle 정의
    onMounted(() => {
      const retrievedState = tb.retrieveAndClearState(
        "vulnNotice",
        "vulnNoticeDetail",
        searchInfo,
        savedSearchInfo,
        pagingInfo
      );
      const {
        type: type,
        searchInfo: parsedSearchInfo,
        pagingInfo: parsedPagingInfo,
      } = retrievedState;
      getList(type);
    });
    // html에서 사용될 데이터 정의
    return {
      pagingInfo,
      searchInfo,
      savedSearchInfo,
      getList,
      items,
      getPage,
      rows,
      convertDateFormatFromId,
      goToDetail,
      convertId,
      isLoading,
    };
  },
};
</script>